import React, { useContext, useEffect } from 'react';
import {
	EditRestaurantContext,
	IEditRestaurantContext,
} from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/editRestaurantState/editRestaurantContext';
import { NfcCardsContext, INfcCardsContext } from '../nfcCardsState/nfcCardsContext';
import { IRestaurantNfcCardsForUpdate } from 'types';
import { NEW_NFC_CARDS_BLOCK_PREFIX } from 'appConstants';
import { preventDefaultForEnterKey } from 'utils/helpers';
import { Form } from 'antd';
import Text from 'components/Text/Text';
import { NfcCardsBlock } from './components/NfcCardsBlock/NfcCardsBlock';
import { BtnBlock } from './components/BtnBlock';
import style from './InputFields.module.scss';

export const InputFields: React.FC = () => {
	const { restaurantId } = useContext<IEditRestaurantContext>(EditRestaurantContext);
	const { changeTypeOfModalWindow, setDataForSubmit, nfcCards } = useContext<INfcCardsContext>(NfcCardsContext);
	const [form] = Form.useForm();

	useEffect(() => {
		nfcCards.forEach((el) => {
			form.setFieldsValue({
				[`uuidCard-${el.id}`]: el.uuid,
				[`fullName-${el.id}`]: el.cardHolder,
				[`nfcCardPermission-${el.id}`]: el.permissions,
			});
		});
	}, [nfcCards]);

	const submit = () => {
		const finalNfcCards: IRestaurantNfcCardsForUpdate[] = nfcCards.map((el) => {
			const isNewNfcCardsBlock = el.id.slice(0, NEW_NFC_CARDS_BLOCK_PREFIX.length) === NEW_NFC_CARDS_BLOCK_PREFIX;

			return {
				id: isNewNfcCardsBlock ? null : el.id,
				uuid: el.uuid || '',
				cardHolder: el.cardHolder || '',
				permissions: el.permissions,
			};
		});

		setDataForSubmit({
			restaurantId,
			restaurantNfcCards: finalNfcCards,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="nfcCardsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<NfcCardsBlock />
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};
